import React from 'react'
import { Button, useRefresh, useNotify, useUnselectAll, } from 'react-admin'
import IconBlock from '@material-ui/icons/Block'
import { assignKeyword } from '../../../Model/Shop'


const handleAssignClick = (shopid, selectedIds, resource, refresh, notify, unselectAll) => {
    const data = {
        "shop_id": shopid,
        "sid[]": selectedIds,
    }
    assignKeyword(data,shopid, (res) => {
        refresh()
        unselectAll(resource)
        notify(res.message)
    }, (res) => {
        notify(res.message, 'warning')
    })

}

const AssignKeywordButton = ({ shopid, selectedIds, resource }) => {
    const refresh = useRefresh()
    const notify = useNotify()
    const unselectAll = useUnselectAll()
    return (
        <Button label="Assign Keyword" icon={<IconBlock />} onClick={() => {
            handleAssignClick(shopid, selectedIds, resource, refresh, notify, unselectAll)
        }} />
    );
}

export default AssignKeywordButton